import { data } from '../../svg/Undo/data';
import { makeIcon } from '../makeIcon';

export const Undo = makeIcon(data, 'undo', 'Undo');

export default Undo;
